<template lang="pug">
  .gl-reset-password.gl-layout--medium-width

    // logo
    .gl-card--logo-above
      img(v-gl-wl="{ insert: 'loginLogo' }")

    // loading: config
    gl-loading-card(:options="{ message: 'Loading application', location: 'page' }" v-if="!config")

    // form
    b-form.gl-card.gl-card--form(@submit.prevent="submitForm" v-if="config" novalidate)
      .gl-card--form__header
        .gl-card--form__header__title Reset Password

      // body
      .gl-card--form__body
        gl-alert(
          :options="{ errorList, infoList, includesHtml: true }"
          @clear-error-list="errorList = []"
          @clear-info-list="infoList = []")
        b-form-group(:state="form.password.state" v-gl-wl="{ apply: [ 'formLabelColor', 'formLabelFontWeight' ] }" label="New Password" label-for="password")
          b-form-input(
            :state="form.password.state"
            v-model.trim="form.password.val"
            v-gl-focus="true"
            required
            type="password")
          .invalid-feedback(v-if="form.password.invalidFeedback") {{ form.password.invalidFeedback }}
        b-form-group(:state="form.confirmedPassword.state" v-gl-wl="{ apply: [ 'formLabelColor', 'formLabelFontWeight' ] }" label="Confirm New Password" label-for="confirmedPassword")
          b-form-input(
            :state="form.confirmedPassword.state"
            v-model.trim="form.confirmedPassword.val"
            required
            type="password")
          .invalid-feedback(v-if="form.confirmedPassword.invalidFeedback") {{ form.confirmedPassword.invalidFeedback }}

      // footer
      .gl-card--form__footer
        gl-btn(:options="{ label: 'Save New Password', size: 'full-width', type: 'submit', style: 'brand', isLoading: isLoading.submitForm }")
        router-link.gl-card--form__footer__link(:to="{ name: 'login' }" v-gl-wl="{ apply: 'linkColor' }") Sign In
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  // computed
  computed: {
    ...mapGetters(['config'])
  },

  // data
  data () {
    return {
      infoList: [],
      errorList: [],
      form: {
        password: { val: '', state: null, invalidFeedback: '' },
        confirmedPassword: { val: '', state: null, invalidFeedback: '' }
      },
      isLoading: {
        submitForm: false
      }
    }
  },

  // methods
  methods: {
    submitForm () {
      // clear previous errors / messages
      this.infoList = []
      this.errorList = []

      // clear previous feedback
      this.$glForm.clearFeedback(this.form)

      // if form is valid
      if (this.validateForm()) {
        // start loading
        this.isLoading.submitForm = true

        // build request w/ the val attribute from each item in this.form
        let request = this.$glForm.getVals(this.form)

        // add hash to request
        request.hash = this.$route.params.hash

        // reset password
        return this.$glHttp.post('user/reset-password', request)
          .then(() => {
            // push info message
            this.infoList.push('Password updated successfully')
          })
          .catch(e => {
            // push errors
            this.errorList.push(this.$glForm.parseError(e))
          })
          .finally(() => {
            // stop loading
            this.isLoading.submitForm = false
          })
      } else {
        // focus first error
        this.$glForm.focusFirstError({ el: this.$el })
      }
    },
    validateForm () {
      // if no password -> invalid
      if (!this.form.password.val) {
        this.form.password.state = 'invalid'
        this.form.password.invalidFeedback = 'A new password is required'
      }
      // if no confirmedPassword -> invalid
      if (!this.form.confirmedPassword.val) {
        this.form.confirmedPassword.state = 'invalid'
        this.form.confirmedPassword.invalidFeedback = 'A confirmed password is required'
      }
      // if passwords are supplied but do not match -> push errors
      if (this.form.password.val && this.form.confirmedPassword.val && this.form.password.val !== this.form.confirmedPassword.val) {
        this.errorList.push('New Password and Confirm Password are not the same')
      }

      // return true if no fields are invalid && the errorList is empty
      return (this.$glForm.hasNoInvalid(this.form) && this.errorList.length === 0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ResetPassword.vue